export const referenceCardSelectedPagRefName = 'referenceCardSelectedPagRef';

export const referenceCardSelectedPagRefProjection = `{
  _id,
  _type,
  wistiaVideoMetadata,
  cardImage,
  currentPathname,
  title,
  cardButtonText,
  description,
  "articleDate": coalesce(articleDate, startDateTime.utc),
  _type in ['lumaEvent', 'linkedEvent'] => {
    "title": name,
    "currentPathname": url,
    "articleDate": startDateTime.utc,
  },
}`;

export const referenceCardSelectedPagRefQuery = groq`*[_id == $_id][0] ${referenceCardSelectedPagRefProjection}`;
